import { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { onExportedOnce } from './exported-once';

/** How long the line stays before it clears itself. */
const showMs = 8_000;

/**
 * Over the fields column after a Confirm on a document Paige had already exported: "Already exported: not
 * sent again" (exported-once.ts, ADR-0031). Nothing otherwise, and nothing once dismissed or after a while.
 */
export function ExportedOnceNotice() {
  const [line, setLine] = useState<string | null>(null);
  useEffect(() => onExportedOnce(setLine), []);
  useEffect(() => {
    if (!line) return undefined;
    const timer = window.setTimeout(() => setLine(null), showMs);
    return () => window.clearTimeout(timer);
  }, [line]);
  if (!line) return null;
  return (
    <div className="paige-review-notice" role="status">
      <CheckCircle2 size={14} aria-hidden="true" />
      <span>{line}</span>
      <button type="button" className="quiet-button" onClick={() => setLine(null)}>
        OK
      </button>
    </div>
  );
}
